export const formatDate = (dateString: string | Date): string => {
  if (!dateString) return '';

  // Handle Date objects
  if (dateString instanceof Date) {
    if (isNaN(dateString.getTime())) {
      return 'Invalid Date';
    }
    return dateString.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  }

  // Handle string dates
  if (typeof dateString !== 'string') {
    return 'Invalid Date';
  }

  // Check if already a formatted date string
  if (dateString.includes(' ')) {
    return dateString;
  }

  // Parse as local date to avoid timezone issues
  const parts = dateString.split('-');
  if (parts.length !== 3) {
    return 'Invalid Date';
  }

  const [year, month, day] = parts.map(Number);
  if (isNaN(year) || isNaN(month) || isNaN(day)) {
    return 'Invalid Date';
  }

  const localDate = new Date(year, month - 1, day);

  if (isNaN(localDate.getTime())) {
    return 'Invalid Date';
  }

  return localDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const getStatusColor = (status: string): string => {
  switch (status) {
    case 'todo':
      return '#FFD53C'; // Yellow
    case 'done':
      return '#B4DC19'; // Lime green
    default:
      return '#6b7280';
  }
};
